import React from 'react';
import './News.css';
import new1 from '../../Assets/Images/new1.avif';
import new2 from '../../Assets/Images/new2.avif';
import news3 from '../../Assets/Images/news3.avif';
import news4 from '../../Assets/Images/news4.avif';
import new5 from '../../Assets/Images/new5.avif';
import news6 from '../../Assets/Images/news6.avif';

import del1 from '../../Assets/Images/del1.webp';
import del2 from '../../Assets/Images/del2.webp';
import del3 from '../../Assets/Images/del3.webp';
import del4 from '../../Assets/Images/del4.webp';

const NewsSection = () => {
  return (
    <div className="news-section">
      <div className="top-banner">
        <p>We understand that you have a lot on your plate, together let's #accomplishmore</p>
        <a href="#know-more">Know more</a>
      </div>

      <div className="news">
        <h2>WE HAVE SOME NEWS!</h2>
        <div className="news-logos">
          <img src={new1} alt="Hindustan Times" />
          <img src={new2} alt="India Today" />
          <img src={news3} alt="The Times of India" />
          <img src={news4} alt="Lifestyle Asia" />
          <img src={new5} alt="Elle" />
          <img src={news6} alt="Bazaar" />
        </div>
      </div>

      <div className="delivering-more">
        <h2>DELIVERING MORE</h2>
        <div className="icons">
          <div className="icon-item">
            <img src={del1} alt="Warranty" />
            <p>6 Months warranty</p>
          </div>
          <div className="icon-item">
            <img src={del2} alt="Shipping" />
            <p>Free Shipping</p>
          </div>
          <div className="icon-item">
            <img src={del3} alt="Exchange" />
            <p>Easy exchange</p>
          </div>
          <div className="icon-item">
            <img src={del4} alt="Checkout" />
            <p>Secure Checkout</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsSection;
